<template>
  <etg-button class="-ml-3" icon="copy" size="small" @click="doCopy(props.address)">
    {{ props.text }}
  </etg-button>
</template>

<script lang="ts" setup>
interface Props {
  address: string
  text: string
}

const props = defineProps<Props>()

const { doCopy } = useEtgClipboard()
</script>
